import { GLOBAL_ENUM_KEYS } from './enums/enum-loc-keys';
import { enumLocs } from './enums/enum.locs';
import { GLOBAL_ERROR_KEYS, errorLocs } from './errors.locs';
import { examsDataLocs } from './feature/exams/exams-data.locs';
import { GLOBAL_SYSTEM_LOCS, systemGlobalLocs } from './system.locs';

export {
	EXAMS_DATA_SYSTEM_LOCS as ExamLocKeys,
	examsDataLocs as ExamLocs,
} from './feature/exams/exams-data.locs';

export { GLOBAL_ERROR_KEYS as GlobalErrorKeys, errorLocs as GlobalErrorLocs } from './errors.locs';

export const systemLocs = {
	...errorLocs,
	...systemGlobalLocs,
	...enumLocs,
	...examsDataLocs,
};

export const SYSTEM_LOC_KEYS = {
	Errors: GLOBAL_ERROR_KEYS,
	GlobalValues: GLOBAL_SYSTEM_LOCS,
	Enums: GLOBAL_ENUM_KEYS,
};
